import { PatientSearchOptionWithBirthDate } from '../../../../../common/enums/patientSearchOptionWithBirthDate';
import { getObjectKeys } from '../../../../../common/utils/getObjectKeys';
import { translateKey } from '../../../../translate';
import { PatientSearchWithBirthdateAndOtherOptions } from '../searchPatient/PatientSearchWithBirthdateAndOtherOptions';

export function PatientSsoInsufficientData() {
    return (
        <PatientSearchWithBirthdateAndOtherOptions
            defaultSearchOptionWithBirthDate={PatientSearchOptionWithBirthDate.identifierSocialSecurity}
            header={translateKey('patientSso.patientNotFound')}
            searchOptionsWithBirthDate={getRadioOptions()}
            thirdHeader={translateKey('patientSso.searchPatient')}
        />
    );

    function getRadioOptions() {
        return getObjectKeys(PatientSearchOptionWithBirthDate) as PatientSearchOptionWithBirthDate[];
    }
}
